import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class GroupStylingModel extends CoreStylingModel {
/**
 * Styling for the group label
 */
label?: StylingModel;
/**
 * Styling for the group content
 */
content?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function GroupStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for the group label
 * @type {?}
 */
GroupStylingModel.prototype.label;
/**
 * Styling for the group content
 * @type {?}
 */
GroupStylingModel.prototype.content;
}

